export const COMPANY_PAGE_TYPE_NONE = 'none';
export const COMPANY_PAGE_TYPE_STUDY = 'study';
export const COMPANY_PAGE_TYPE_HOT = 'hot';
export const COMPANY_PAGE_TYPE_OPTION_A = 'optionA';
export const COMPANY_PAGE_TYPE_SMALL = 'small';
export const COMPANY_PAGE_TYPE_MEDIUM = 'medium';
export const COMPANY_PAGE_TYPE_LARGE = 'large';
export const COMPANY_PAGE_TYPE_TINY = 'tiny';
